import React from "react";
import "./TabPanel.css";

export interface TabPanelProps {
  /**
   * ID of the tab this panel is associated with
   */
  tabId: string;

  /**
   * Whether this panel is currently active
   */
  isActive: boolean;

  /**
   * Content to display in the tab panel
   */
  children: React.ReactNode;

  /**
   * Additional CSS class name
   */
  className?: string;

  /**
   * Whether to keep the panel in the DOM when inactive (but hidden)
   */
  keepMounted?: boolean;
}

/**
 * A component for rendering tab panel content that is associated with a tab
 */
const TabPanel: React.FC<TabPanelProps> = ({
  tabId,
  isActive,
  children,
  className = "",
  keepMounted = false,
}) => {
  // If not active and not keepMounted, don't render anything
  if (!isActive && !keepMounted) {
    return null;
  }

  return (
    <div
      id={`tabpanel-${tabId}`}
      role="tabpanel"
      aria-labelledby={`tab-${tabId}`}
      hidden={!isActive}
      className={`tab-panel ${isActive ? "active" : ""} ${className}`}
      data-testid={`tabpanel-${tabId}`}
    >
      {children}
    </div>
  );
};

export default TabPanel;
